export const configurationTypes = [
  'maintenance',
  'enquiry-types',
  'updating-structures',
];
